export default __webpack_public_path__ + "static/g-computer-ii-22eb449bb4a93522d31ea6b76ab408ec.jpg";